import http from '@/utils/http/http'

//账号密码登录
export function loginForPassword (data) {
  return http.post('/sys/auth/login', data)
}

export function getUserInfo (data) {
  return http.get('/sys/user/info',data,{auth: true})
}
//用户登出
export function logout(data) {
  return http.get('/sys/auth/logout', data)
}
